import React from "react";
import { makeStyles, Link as MuiLink } from "@material-ui/core";
import Link from "next/link";

export default function LinkItem({ hovered, children, selected, external, href, rel }) {
  const classes = useStyle({ selected, hovered });

  if (external) {
    return (
      <MuiLink href={href} className={classes.link} underline="none">
        {children}
      </MuiLink>
    );
  }

  return (
    <Link href={href} passHref>
      <MuiLink className={classes.link} underline="none" rel={rel}>
        {children}
      </MuiLink>
    </Link>
  );
}

const useStyle = makeStyles((theme) => ({
  link: {
    fontSize: 16,
    lineHeight: "140%",
    fontWeight: 500,
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    color: (props) => (props.selected || props.hovered ? theme.palette.primary.main : "inherit"),
  },
}));
